import styled from 'styled-components';

const Img = styled.img`
  width: 100%;
  max-width: 17em;
`;

export default Img;



// WEBPACK FOOTER //
// ./client/components/HomePage/FeaturedProducts/FeaturedProductGrid/FeaturedProduct/Img.js